import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  copyPhoneNumber = (event) => {
    navigator.clipboard.writeText(event.params.phoneNumber);
  };

  copyEmailAddress = (event) => {
    navigator.clipboard.writeText(event.params.emailAddress);
  };
}
